import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import CareerPage from './pages/Carrier';
import Projects from './pages/Projects';
import ApplyForm from './components/ApplyForm/ApplyForm';
import SignUp from './components/Auth/Signup';
import Login from './components/Auth/Login';
import NewDashboard from './pages/NewDashboard';
import Events from './pages/Events';
import Contact from './pages/Contact';
import ForgotPassword from './components/Auth/Forget-password';
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import { Analytics } from "@vercel/analytics/react"; 
function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/opportunities" element={<CareerPage />} />
          <Route path="/apply/:jobId" element={<ApplyForm />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<NewDashboard />} />
          <Route path="/events" element={<Events />} />
          <Route path="/forgetpass" element={<ForgotPassword />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* Add more routes as needed */}
        </Routes>

        <Analytics />
      </div>
    </Router>
  );
}

export default App;
